import { Controller } from "@hotwired/stimulus";

interface StatusPayload {
  status: string;
  total: number;
  completed: number;
  created_group_ids: number[];
  error_log: string;
}

export default class extends Controller {
  static targets = ["progress", "state", "groups", "errors"];
  static values = { url: String };

  declare progressTarget: HTMLElement;
  declare stateTarget: HTMLElement;
  declare groupsTarget: HTMLElement;
  declare errorsTarget: HTMLElement;

  declare urlValue: string;

  private timer: ReturnType<typeof setTimeout> | null = null;

  connect(): void {
    this.poll();
  }

  disconnect(): void {
    if (this.timer !== null) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }

  private async poll(): Promise<void> {
    const response = await fetch(this.urlValue, {
      headers: { Accept: "application/json" },
    });
    const data: StatusPayload = await response.json();

    this.progressTarget.textContent = `${data.completed} / ${data.total}`;
    this.stateTarget.textContent = data.status;
    this.errorsTarget.textContent = data.error_log;
    this.groupsTarget.innerHTML = (data.created_group_ids || [])
      .map(
        (id) =>
          `<li class="mb-1"><a href="/admin/groups/${id}" class="btn btn-falcon-default btn-sm"><i class="fas fa-external-link-alt mr-1"></i>Group #${id}</a></li>`
      )
      .join("");

    if (data.status === "completed" || data.status === "failed") return;

    this.timer = setTimeout(() => this.poll(), 2000);
  }
}
